import { Link } from "@tanstack/react-router"

import { SummaryAccordionItem } from "@/components/summary/SummaryAccordion"
import { AccordionContent } from "@/components/ui/accordion"
import { Badge } from "@/components/ui/badge"

import type { Company } from "@boundless/bl-api-client/customer/models"

type SummaryBankingConnectionProps = {
  company: Company
  returnTo: string
}

export function SummaryBankingConnection({
  company,
  returnTo,
}: SummaryBankingConnectionProps) {
  return (
    <SummaryAccordionItem
      value="banking-connection"
      title="Banking Connection"
      checkIcon={company.hasHeronLink}
    >
      <AccordionContent className="px-4 pt-2 pb-4">
        <div className="mb-4 flex items-center justify-end">
          <Link
            className="text-primary hover:underline"
            to="/company/plaid"
            search={{ returnTo }}
          >
            Edit
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-y-1">
          <div className="text-sm text-gray-600">Plaid</div>
          <div className="text-sm">
            {company.hasHeronLink ? (
              <Badge className="border-transparent bg-green-100 text-green-800">
                Connected
              </Badge>
            ) : (
              <Badge variant="secondary">Not Connected</Badge>
            )}
          </div>
        </div>
      </AccordionContent>
    </SummaryAccordionItem>
  )
}
